import script from "./OtherFeeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherFeeForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__